var _defs, _path, _circle, _line, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _circle2, _circle3, _circle4, _path1, _path10, _path11, _path12, _path13, _polyline, _path14, _path15, _line2, _line3, _path16, _path17, _rect, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 324 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e1e6ea;}.cls-2{fill:#f9f9f9;}.cls-3,.cls-4,.cls-6,.cls-8{fill:none;stroke-linecap:round;}.cls-3{stroke:#fff;stroke-width:2px;}.cls-3,.cls-4{stroke-miterlimit:10;}.cls-4,.cls-6{stroke:#3c4650;}.cls-4{stroke-width:1.25px;}.cls-5{fill:#bec4ca;}.cls-6,.cls-8{stroke-linejoin:round;}.cls-7{fill:#ccc;opacity:0.29;}.cls-8{stroke:#ff4338;}.cls-9{fill:#ff4338;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "connection") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M254.16,81V185.54a4.3,4.3,0,0,0,4.3,4.3H311a4.3,4.3,0,0,0,4.3-4.3V81a4.3,4.3,0,0,0-4.3-4.3H258.45A4.3,4.3,0,0,0,254.16,81Zm7.54,17.38a3.63,3.63,0,0,1,3.63-3.63h41A3.63,3.63,0,0,1,310,98.34v72.34a3.63,3.63,0,0,1-3.63,3.63h-41a3.63,3.63,0,0,1-3.63-3.63Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 285.45,
    cy: 181.75,
    r: 3.94
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 281.4,
    y1: 85.77,
    x2: 289.13,
    y2: 85.77
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M255.54,139.91v48.52a4.3,4.3,0,0,0,4.3,4.3h52.54a4.3,4.3,0,0,0,4.3-4.3V172.81"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M259.85,79.54h52.54a4.3,4.3,0,0,1,4.3,4.3v54.6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M275.61,79.54H259.84a4.3,4.3,0,0,0-4.3,4.3V97.31"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.1,154.27a6.39,6.39,0,0,0,6.39,6.39H208.34a6.39,6.39,0,0,0,6.39-6.39V49.85a6.39,6.39,0,0,0-6.39-6.39H30.49a6.39,6.39,0,0,0-6.39,6.39M204.31,147.4a5.39,5.39,0,0,1-5.39,5.4H41.06a5.39,5.39,0,0,1-5.39-5.39V60.05a5.39,5.39,0,0,1,5.39-5.39H198.92a5.39,5.39,0,0,1,5.39,5.39Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M223.59,181.51c-2-2.31-4.44-5.26-5.71-6.74-2.67-3.27-4.62-4.67-9.08-4.67H31c-4.46,0-6.41,1.4-9.08,4.67-1.28,1.48-3.68,4.43-5.71,6.74s-1.92,5,4.57,5H219C225.51,186.47,225.62,183.82,223.59,181.51Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M25.29,83.65V51.44a6.39,6.39,0,0,1,6.39-6.39H209.52a6.39,6.39,0,0,1,6.39,6.39v65.18"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M47.69,162.25H31.13a5.84,5.84,0,0,1-5.85-5.85V125.13"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M216.77,141.95v13.92a6.39,6.39,0,0,1-6.39,6.39H118.26"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M234,186.14c-2.78-3.16-6.08-7.19-7.82-9.21-3.65-4.49-6.32-6.39-12.42-6.39H26.51c-6.1,0-8.76,1.91-12.42,6.39-1.74,2-5,6-7.82,9.21s-2.62,6.79,6.26,6.79H227.78C236.66,192.93,236.81,189.31,234,186.14Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 273.58,
    cy: 131.39,
    r: 3.75
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 285.81,
    cy: 131.39,
    r: 3.75
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 296.74,
    cy: 131.39,
    r: 3.75
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M281.85,142s-.45,7-4.68,10.91a9.48,9.48,0,0,0,4.85-.68c3.85-1.61,6.75-5.47,8.19-10.23h13.67c2.08,0,3.76-2.33,3.76-5.2V126.41c0-2.87-1.68-5.2-3.76-5.2H173.13"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M173.13,125.64a7,7,0,0,1-7,7H103.67S99,146.45,83.51,146.45c6.64-4.56,4.34-13.85,4.34-13.85h-11a7,7,0,0,1-7-7v-51a7,7,0,0,1,7-7h89.28a7,7,0,0,1,7,7Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M84,77.7h65.93a5.43,5.43,0,0,1,5.34,5.45,5.34,5.34,0,0,1-5.34,5.34h-61a5.44,5.44,0,0,0-5.34,5.45,5.34,5.34,0,0,0,5.34,5.34h61a5.43,5.43,0,0,1,5.34,5.45,5.34,5.34,0,0,1-5.34,5.34H121.84"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M92,114.65v1.62c0,.15,0,1.17-1,1.17H89.8c-.87,0-.92-.88-.92-1.17v-1.62Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M85.5,114.45V117c0,1.08.16,4.36,3.43,4.36H91.2c3.8,0,3.81-3.82,3.81-4.36v-2.32h12.57v4.67H104"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "116.7 114.65 111.72 114.65 111.72 119.32 114.94 119.32"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M66.61,118l-.07,6.14a6.8,6.8,0,0,0,6.8,6.8H85.4a23.83,23.83,0,0,1-8.45,14.46,23.26,23.26,0,0,0,23.56-14.27h21.74"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M66.53,91.83V71a6.8,6.8,0,0,1,6.8-6.8h89.78a6.8,6.8,0,0,1,6.8,6.8v46s-.54,4.34,3.21,4.34"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 85.86,
    y1: 110.07,
    x2: 116.7,
    y2: 110.07
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 293.21,
    y1: 149.74,
    x2: 300.94,
    y2: 149.74
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M300.17,149.84v3a2.1,2.1,0,0,1-2.09,2.1h-2a2.1,2.1,0,0,1-2.09-2.1v-3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M295.14,149.6v-2.33a1.27,1.27,0,0,1,1.23-1.3h1.41a1.27,1.27,0,0,1,1.23,1.3v2.33"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 296.49,
    y: 151.11,
    width: 1.16,
    height: 0.77
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "297.65 153.43 296.49 153.43 296.92 151.88 297.24 151.88 297.65 153.43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnection);
export default __webpack_public_path__ + "static/media/connection.c75cc032dd047ceb2aa47f9ad54809b7.svg";
export { ForwardRef as ReactComponent };